import api from '../services/api';
import { Pagination } from '../utils/pagination';
import { $Q, $Qll } from '../utils/querySelector';

class CollectionSearch {
  constructor() {
    this.container = $Q('#collections-list');
  }

  /**
   * Initialize search functionalities
   */
  async _init() {
    await this.fetchCollections();
    await this.getPagination();
    await this.getDefaultImage();

    const noLength = this.createCategoryDom();
    if (noLength) return;

    this.showCollections();

    return this.length;
  }

  /**
   * It fetchs collectino info through predictive search api
   */
  async fetchCollections() {
    const href = window.location.href;
    const query = href.split('?')[1];
    const queryParam = query.split('q=')[1].split('&')[0];

    const base_url = `${routes.predictive_search_url}?q=${encodeURIComponent(
      queryParam
    )}&${encodeURIComponent(
      'resources[type]'
    )}=collection&section_id=collection-search`;

    const response = await fetch(base_url);
    const responseText = await response.text();
    const resultsDOM = new DOMParser().parseFromString(
      responseText,
      'text/html'
    );

    this.collectionsDOM = resultsDOM;
  }

  async getDefaultImage() {
    const response = await api.shopifyByUrlAndParams('/search', {});
    const resultsDOM = new DOMParser().parseFromString(
      response.data,
      'text/html'
    );

    const noImgElement = $Q(
      '.wrapper-collections .collection-no-image',
      resultsDOM
    );

    this.collectionNoImg = noImgElement.dataset.src;
  }

  setDefaultImage(item, url) {
    if (!item) return;

    const imgWrapper = $Q('.article-card__img-wrapper', item);
    if ($Q('a', imgWrapper)) return;

    const imgContainer = `
      <a href="${url}">
        <img
          class="blur-up lazyautosizes lazyloaded"
          loading="lazy"
          src=${this.collectionNoImg}
        />
      </a>`;

    imgWrapper.innerHTML = imgContainer;

    return imgWrapper;
  }

  /**
   * It gets pagination settings
   */
  getPagination() {
    const resultsContainer = $Q('.results-container', this.collectionsDOM);
    if (!resultsContainer) return;

    this.paginationBy = resultsContainer.dataset.pagination;
  }

  /**
   * Create category for collection in DOM
   */
  createCategoryDom() {
    this.collectionsList = $Qll(
      '.wrapper-collections .results-wrapper li',
      this.collectionsDOM
    );
    this.length = Object.values(this.collectionsList).length;

    if (!this.length) return true;

    const categoryPagination = new Pagination(
      this.collectionsDOM,
      this.paginationBy,
      'collections'
    );

    this.pageObject = categoryPagination;

    const container = this.createContainer();
    const pagination = categoryPagination.createPaginationDOM();
    categoryPagination.updateHeaderInfo();
    const categoryContent = this.createCategoryContent(
      Object.values(this.collectionsList)
    );

    container.dataset.id = 'Collections';

    Object.values(categoryPagination.pagination).forEach((page, index) => {
      // Each page holds the <li> results, so it must be the list itself
      const pageElement = document.createElement('ul');
      pageElement.classList.add('page', 'search-results__results-list');
      pageElement.setAttribute('role', 'list');

      if (index > 0) {
        pageElement.classList.add('hidden');
      }
      pageElement.dataset.id = index + 1;

      page.forEach((item) => {
        const _item = item;
        const url = _item.dataset.url;

        const imgWrapper = this.setDefaultImage(item, url);

        if (imgWrapper) {
          const imgDiv = $Q('.article-card__img-wrapper', _item);
          imgDiv.replaceWith(imgWrapper);
        }

        pageElement.appendChild(_item);
      });

      categoryContent.appendChild(pageElement);
    });

    container.appendChild(categoryContent);

    if (pagination) {
      container.appendChild(pagination);
      categoryPagination.readClick(container);
    }

    this.container.appendChild(container);

    setTimeout(() => {
      this.sumCategoryTotal(null, this.length);
    }, 500);
  }

  sumCategoryTotal() {
    const totalText = $Q('.search-results__total #quantity');

    if (totalText && totalText.innerText.trim()) {
      const numberQuantity = parseInt(totalText.dataset.quantity);
      totalText.dataset.quantity = numberQuantity + this.length;
      totalText.innerHTML = numberQuantity + this.length;
    }
  }

  /**
   * It creates a container for collection category
   * @returns {HTMLElement} container : It is the created html container
   */
  createContainer() {
    const container = document.createElement('div');
    container.classList.add('category-container');

    return container;
  }

  /**
   * It creates the content for the collection category
   * @param {Array} list : It is an HTMLElements array
   * @returns {categoryList}
   */
  createCategoryContent(list) {
    // Wrapper of the paginated <ul> pages: a <ul> here would get <ul> children
    const categoryList = document.createElement('div');
    categoryList.classList.add('results-list');

    list.forEach((element) => {
      categoryList.appendChild(element);
    });

    return categoryList;
  }

  showCollections() {
    this.container.classList.remove('hidden');
  }
}

export { CollectionSearch };
